// src/pages/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.username, form.password);
      nav('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'هەڵەیەک ڕووی دا');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.bg}>
      <div style={styles.card}>
        <div style={styles.logoBox}>
          <div style={styles.logo}>🏛️</div>
          <h1 style={styles.title}>حکومەتی هەرێمی کوردستان</h1>
          <p style={styles.sub}>سیستەمی دەرماڵەی خێزانداری و منداڵان</p>
        </div>
        <form onSubmit={submit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>ناوی بەکارهێنەر</label>
            <input
              style={styles.input}
              value={form.username}
              onChange={e => setForm({...form, username: e.target.value})}
              placeholder="username"
              required autoFocus
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>وشەی نهێنی</label>
            <input
              style={styles.input}
              type="password"
              value={form.password}
              onChange={e => setForm({...form, password: e.target.value})}
              placeholder="••••••••"
              required
            />
          </div>
          <button style={{...styles.btn, opacity: loading ? 0.7 : 1}} disabled={loading}>
            {loading ? 'چاوەڕوانبە...' : 'چوونەژوورەوە'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  bg: { minHeight:'100vh', background:'linear-gradient(135deg,#1a5276 0%,#2980b9 100%)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Traditional Arabic,Arial,sans-serif', direction:'rtl' },
  card: { background:'#fff', borderRadius:16, padding:'40px 36px', width:380, boxShadow:'0 20px 60px rgba(0,0,0,0.3)' },
  logoBox: { textAlign:'center', marginBottom:28 },
  logo: { fontSize:48, marginBottom:8 },
  title: { fontSize:16, fontWeight:'bold', color:'#1a5276', margin:'0 0 4px' },
  sub: { fontSize:12, color:'#666' },
  form: { display:'flex', flexDirection:'column', gap:16 },
  field: { display:'flex', flexDirection:'column', gap:4 },
  label: { fontSize:13, fontWeight:'bold', color:'#444' },
  input: { padding:'10px 12px', border:'2px solid #e0e0e0', borderRadius:8, fontSize:14, outline:'none', transition:'border 0.2s', fontFamily:'inherit' },
  btn: { background:'linear-gradient(135deg,#1a5276,#2980b9)', color:'#fff', border:'none', borderRadius:8, padding:'12px', fontSize:15, fontWeight:'bold', cursor:'pointer', marginTop:8, fontFamily:'inherit' },
};
